export default __webpack_public_path__ + "static/media/39t.3902c1f7.jpg";